<div class="w-100 d-flex flex-column">
  <div class="d-flex flex-wrap flex-sm-nowrap mb-3 mt-0"
       [ngClass]="{ 'mb-2': !!toggleFilter }">
    <div class="px-3 px-sm-0 mb-25 mb-sm-0 flex-grow-1 pe-sm-3 search-min-width">
      <flo-search-input-next-gen
        [searchTerm]="searchTerm"
        stretchy="true"
        (search)="handleSearch($event)"
        placeholder="Search All Events"
        data-test="results-search"
      ></flo-search-input-next-gen>
    </div>
    <div *ngIf="filtersSection && filtersSection.items.length > 0"
         class="overflow-auto"
         data-test="filters">
      <flo-filters
        [items]="filtersSection.items"
        (singleFilterClicked)="handleSingleFilterClicked($event)"
        [clearAll]="clearAll"
        [showOutline]="true"
      >
      </flo-filters>
    </div>
  </div>
  <ng-container *ngIf="tabItems && tabItems.length > 0">
    <div class="pe-3 pe-sm-0 border-bottom border-grey-300 d-flex justify-content-between flex-column-reverse flex-md-row">
      <div class="d-flex flex-row justify-content-between justify-content-lg-start date-controls">
        <div class="date-bar me-lg-4"   [ngClass]="{'datepicker-visible': !!dateMode && dateMode === 'daily'}">
          <flo-date-bar [items]="tabItems"></flo-date-bar>
        </div>
        <div *ngIf="!!dateMode && dateMode === 'daily'" class="date-picker my-2 ms-lg-1 d-flex">
          <flo-date-picker
            [selectedDate]="selectedDate"
            (dateSelected)="datePickerSelected($event)"
            [analyticsProperties]="action && action.analytics ? action.analytics : null"
            [placement]="'bottom-right'">
          </flo-date-picker>
        </div>
      </div>
      <div *ngIf="toggleFilter"
           class="d-flex flex-row align-items-center justify-content-between justify-content-lg-start
           ps-3 ps-sm-0 mb-25 mb-md-0 ms-md-2 toggle-filter" data-test="toggle">
        <flo-toggle class="w-100"
          [toggleFilter]="toggleFilter"
          [toggleOutline]="false"
          (toggledTo)="handleSingleFilterClicked($event)">
        </flo-toggle>
      </div>
    </div>
  </ng-container>
</div>
